import visa from 'spa/images/icons/visa.svg';
import mastercard from 'spa/images/icons/mastercard.svg';
import amex from 'spa/images/icons/amex.svg';

export const HAND_CHOICES = [2, 4];
export const HAND_CHOICES_NAMES = ['One Therapist', 'Two Therapists'];
export const CC_YEAR_START = 2015;
export const CLASS_BOOKING_ROUTE = 'class-booking';
export const GROUP_QUERY_CLASS = 'class';
export const GROUP_QUERY_TRAINER = 'trainer';

export const NEW_USER_EXIT_PROMO_POPUP_COOKIE_NAME = 'new_user_exit_promo_popup_dismissed';

// BOOKING FLOW SCREENS
export const SCREEN_ADDRESS = 'address';
export const SCREEN_ADD_TREATMENT_CATEGORY = 'add-treatment-category';
export const SCREEN_ADD_TREATMENT_TREATMENTS = 'add-treatment-treatments';
export const SCREEN_B2B_REDIRECT = 'b2b-redirect';
export const SCREEN_CLASS = 'worker-class';
export const SCREEN_CLASS_ACCOUNT = 'class-account';
export const SCREEN_VERTICAL = 'vertical';
export const SCREEN_TYPE_DURATION = 'type-duration';
export const SCREEN_TYPE_DURATION_2 = 'type-duration2';
export const SCREEN_LOADING = 'loading';
export const SCREEN_TREATMENT = 'treatment';
export const SCREEN_TREATMENT_2 = 'treatment2';
export const SCREEN_SLOT = 'therapist/slot';
export const SCREEN_ACCOUNT = 'account';
export const SCREEN_CHECKOUT = 'checkout';

// TODO remove the above and change the below to just booking when booking-next is released
export const BOOKING_BASE_URL = 'booking-next';

export const EMPTY_CONTENT_REGEX = /(\r\n|\n|\r)/gm;

export const APPOINTMENT_TYPE = {
  ONE_ON_ONE: 'one-on-one',
  CLASSES: 'classes',
};

// NEW BASKET FLOW - remove with routing change
export const SCREEN_SELECT_ADDRESS = 'address';
export const SCREEN_SELECT_CATEGORY = 'select-category';
export const SCREEN_SELECT_SUB_CATEGORY = 'select-sub-category';
export const SCREEN_SELECT_SPECIALITY = 'select-speciality';
export const SCREEN_SELECT_WORKER_SLOTS = 'select-worker-slots';

export const CHILD_TYPE_CATEGORIES = 'categories';
export const CHILD_TYPE_SPECIALITIES = 'specialities';

export const WORKER_PANEL_TAB_OPTIONS = {
  ABOUT: 'about',
  BIO: 'bio',
  PORTFOLIO: 'portfolio',
  REVIEWS: 'ratings',
};

export const CARD_TYPES = [
  {
    name: 'amex',
    test: /^3(4|7)/,
    cvvLength: 4,
    props: {
      icon: amex,
      mask: '9999-999999-99999',
      pattern: '\\d{4}-?\\d{6}-?\\d{5}',
    },
  },
  {
    name: 'diners_club_carte_blanche',
    test: /^30[0-5]/,
    props: {
      mask: '9999-999999-9999',
      pattern: '\\d{4}-?\\d{6}-?\\d{4}',
    },
  },
  {
    name: 'diners_club_international',
    test: /^36/,
    props: {
      mask: '9999-999999-9999',
      pattern: '\\d{4}-?\\d{6}-?\\d{4}',
    },
  },
  {
    name: 'jcb',
    test: /^35(28|89)/,
    props: {
      mask: '9999-9999-9999-9999',
      pattern: '(\\d{4}-?){3}\\d{4}',
    },
  },
  {
    name: 'laser',
    test: /^6(304|706|709|771)/,
    valid_length: [16, 17, 18, 19],
  },
  {
    name: 'visa_electron',
    test: /^4(026|17500|508|844|913|917)/,
    props: {
      icon: visa,
      mask: '9999-9999-9999-9999',
      pattern: '(\\d{4}-?){3}\\d{4}',
    },
  },
  {
    name: 'visa',
    test: /^4/,
    props: {
      icon: visa,
      mask: '9999-9999-9999-9999999',
      pattern: '(\\d{4}-?){3}\\d{1,7}',
    },
  },
  {
    name: 'mastercard',
    test: /^(5[1-5]|2(22[1-9]|2[3-9][0-9]|[3-6][0-9]{2}|7[01][0-9]|720))/,
    props: {
      icon: mastercard,
      mask: '9999-9999-9999-9999',
      pattern: '(\\d{4}-?){3}\\d{4}',
    },
  },
  {
    name: 'discover',
    test: /^6(011|22(12[6-9]|1[3-9][0-9]|[2-8][0-9]{2}|9[01][0-9]|92[0-5])|4[4-9]|5)/,
    props: {
      mask: '9999-9999-9999-9999',
      pattern: '(\\d{4}-?){3}\\d{4}',
    },
  },
  {
    name: 'dankort',
    test: /^5019/,
    props: {
      mask: '9999-9999-9999-9999',
      pattern: '(\\d{4}-?){3}\\d{4}',
    },
  },
  {
    name: 'maestro',
    test: /^(5[06-9]|6[0-9])/,
    props: {
      icon: mastercard,
      mask: '9999-9999-9999-9999999',
      pattern: '(\\d{4}-?){3}\\d{0,7}',
    },
  },
  {
    name: 'uatp',
    test: /^1/,
    props: {
      mask: '9999-99999-9999999',
      pattern: '\\d{4}-?\\d{5}-?\\d{7}',
    },
  },
];




// WEBPACK FOOTER //
// ./utils/constants.jsx